import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mb-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "mb-2" }, "Encuentra aquí las solicitudes realizadas", -1)
const _hoisted_3 = { class: "card card-custom my-3 border" }
const _hoisted_4 = { class: "card-header flex-wrap" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}
const _hoisted_8 = {
  key: 1,
  class: "fa fa-search"
}
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "card-title text-center mb-6" }
const _hoisted_12 = { class: "card-text" }
const _hoisted_13 = { class: "card-text" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "card-text" }
const _hoisted_16 = { class: "card-text" }
const _hoisted_17 = { class: "card-text" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "card-text" }
const _hoisted_20 = { class: "card-footer px-8 py-4" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-list mx-0 px-0",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-folder-open mx-0 px-0",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-pen mx-0 px-0",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_LineTime = _resolveComponent("LineTime")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_DialogFileList = _resolveComponent("DialogFileList")!
  const _component_DialogRectify = _resolveComponent("DialogRectify")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h3", _hoisted_1, "Mis Trámites (" + _toDisplayString(_ctx.listExpedients.length) + ")", 1),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.formSearch.nro_proceedings,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formSearch.nro_proceedings) = $event)),
            clearable: "",
            placeholder: "Número de solicitud"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_select, {
            modelValue: _ctx.formSearch.mstatus,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formSearch.mstatus) = $event)),
            clearable: "",
            multiple: "",
            "collapse-tags": "",
            "collapse-tags-tooltip": "",
            placeholder: "Estado",
            class: "mx-3 w-300px"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatusDocs, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: `lstsd-${item.id}`,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "btn btn-sm btn-success mx-2",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7))
              : (_openBlock(), _createElementBlock("i", _hoisted_8)),
            _createTextVNode(" Buscar ")
          ]),
          _createElementVNode("div", {
            class: "btn btn-sm btn-primary",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.newTramite && _ctx.newTramite(...args)))
          }, " Nuevo trámite ")
        ])
      ])
    ]),
    (_ctx.listExpedients.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listExpedients, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-sm-4"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('card mb-6 border border-' + item.params)
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h5", _hoisted_11, " Nro. Expediente: " + _toDisplayString(item.nro_proceedings), 1),
                  _createElementVNode("p", _hoisted_12, "Fecha: " + _toDisplayString(item.created_at), 1),
                  _createElementVNode("p", _hoisted_13, [
                    _createTextVNode(" Procedimiento: "),
                    _hoisted_14,
                    _createTextVNode(_toDisplayString(item.procedure_name), 1)
                  ]),
                  _createElementVNode("p", _hoisted_15, "Folios: " + _toDisplayString(item.nrofolios), 1),
                  _createElementVNode("p", _hoisted_16, " Tiempo del trámite: " + _toDisplayString(item.days_attention) + " días ", 1),
                  _createElementVNode("p", _hoisted_17, [
                    _createTextVNode("Sustento: "),
                    _hoisted_18,
                    _createTextVNode(_toDisplayString(item.message), 1)
                  ]),
                  _createElementVNode("p", _hoisted_19, [
                    _createTextVNode(" Estado: "),
                    _createElementVNode("span", {
                      class: _normalizeClass('badge badge-' + item.params)
                    }, _toDisplayString(item.mstatus_name), 3)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_el_tooltip, {
                    placement: "top-start",
                    content: "Ver estados del expediente"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.getListHistory(item.idtramite)),
                        class: _normalizeClass('btn border btn-sm btn-' + item.params)
                      }, _hoisted_23, 10, _hoisted_21)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_tooltip, {
                    placement: "top-start",
                    content: "Mis archivos presentados"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.onDialogFileList(item)),
                        class: _normalizeClass('btn border btn-sm btn-'+ item.params +' mx-2')
                      }, _hoisted_26, 10, _hoisted_24)
                    ]),
                    _: 2
                  }, 1024),
                  (item.mstatus==4)
                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                        key: 0,
                        placement: "top-start",
                        content: "Subsanar expediente"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.onDialogRectify(item)),
                            class: _normalizeClass('btn border btn-sm btn-'+ item.params)
                          }, _hoisted_29, 10, _hoisted_27)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          "image-size": 200,
          description: "No se encontrarón expedientes"
        })),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogHistory,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogHistory) = $event)),
      title: "Estados del Expediente",
      top: "2vh",
      draggable: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_30, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-custom btn-danger btn-sm",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogHistory = false))
          }, " Cerrar ")
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_LineTime)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_DialogFileList, { expediente: _ctx.expediente }, null, 8, ["expediente"]),
    _createVNode(_component_DialogRectify, {
      expediente: _ctx.expediente,
      onResDialogRectify: _ctx.resDialogRectify
    }, null, 8, ["expediente", "onResDialogRectify"])
  ])), [
    [
      _directive_loading,
      _ctx.fullscreenLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}